<template>
    <span :class="'clear button ' + severity" @click="popup"><i :class="'icon icon-' + icon"></i>{{ text|t }}</span>
</template>

<script>
  export default {
    name: 'ModalDetail',
    props: {
      title: {
        type: String,
        required: true,
      },
      payload: {
        type: String,
        required: true
      },
      icon: {
        type: String,
        default: "enlarge",
      },
      text: {
        type: String,
        required: false,
      },
      severity: {
        type: String,
        required: false,
        default: "primary"
      },
    },
    methods: {
      popup() {
        this.$store.commit('modal/setModal', {title: this.title, content: this.payload}, {root: true});
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ModalDetail.vue